import type { DateTranslations } from 'utils/dates/applyDateTranslations'

export const spanishDateTranslations: DateTranslations = {
  months: {
    full: {
      January: 'enero',
      February: 'febrero',
      March: 'marzo',
      April: 'abril',
      May: 'mayo',
      June: 'junio',
      July: 'julio',
      August: 'agosto',
      September: 'septiembre',
      October: 'octubre',
      November: 'noviembre',
      December: 'diciembre',
    },
    short: {
      Jan: 'ene.',
      Feb: 'feb.',
      Mar: 'mar.',
      Apr: 'abr.',
      May: 'may.',
      Jun: 'jun.',
      Jul: 'jul.',
      Aug: 'ago.',
      Sep: 'sept.',
      Oct: 'oct.',
      Nov: 'nov.',
      Dec: 'dic.',
    },
  },
  days: {
    full: {
      Sunday: 'domingo',
      Monday: 'lunes',
      Tuesday: 'martes',
      Wednesday: 'miércoles',
      Thursday: 'jueves',
      Friday: 'viernes',
      Saturday: 'sábado',
    },
    short: {
      Sun: 'dom.',
      Mon: 'lun.',
      Tue: 'mar.',
      Wed: 'mié.',
      Thu: 'jue.',
      Fri: 'vie.',
      Sat: 'sáb.',
    },
  },
}
